import React from "react";

export default function ResultBox(props){
    return(

        <div className=" bg-white w-100% top-[800px] ml-4 mr-4 mt-4 text-lg rounded-sm">
          <div className="flex font-bold underline decoration-3 p-3 text-blue-800 ">
            Result
          </div>
          <p
            style={{ display: "flex", flexWrap: "wrap", marginTop: "10px" }}
            className=" ml-5 pb-5 mr-5 text-black"
          >
            {props.result} 
          </p>
        </div>


    )
}